// extracted by mini-css-extract-plugin
export var addButton = "_jo-0";
export var border = "_jo-8";
export var check = "_jo-h";
export var danger = "_jo-6";
export var dropdownContainer = "_jo-1";
export var editModalBody = "_jo-j";
export var footerContainer = "_jo-i";
export var fullWidth = "_jo-a";
export var hide = "_jo-9";
export var icon = "_jo-3";
export var input = "_jo-7";
export var inputFlex = "_jo-b";
export var inputWrapper = "_jo-c";
export var manualFocus = "_jo-5";
export var optionButton = "_jo-4";
export var pillWrapper = "_jo-e";
export var pointer = "_jo-2";
export var showOverflow = "_jo-f";
export var tagsFlex = "_jo-d";
export var xButton = "_jo-g";